module.exports = __webpack_public_path__ + "img/29a.e857214e.png";